import { FC, JSX } from 'react';
import styles from './ResidentialComplexesList.css';

type ResidentialComplexesListProps = {
  complexesList: JSX.Element[];
  showMoreButton: JSX.Element | null;
};

export const ResidentialComplexesList: FC<ResidentialComplexesListProps> = props => {
  const { complexesList, showMoreButton } = props;

  return (
    <div className={styles['complexes']}>
      <div className={styles['cards']}>{complexesList}</div>
      {!!showMoreButton && <div className={styles['button-wrapper']}>{showMoreButton}</div>}
    </div>
  );
};
